module.exports = __webpack_public_path__ + "static/media/sf.efa7c8dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sf.jpg
// module id = 417
// module chunks = 0